export default "__VITE_ASSET__BCkyn9$B__"